export default "__VITE_ASSET__G43OgUhf__"